import MuNavToggles from "./MuNavToggles";
import MuNavOpenActivePath from "./MuNavOpenActivePath";
export default class MuNavMobile {
    _desktopWidth = 1200; //1024;
    _isOpen = false;
    _navItems = [];
    _scrollTop = 0;
    _deactive = false;

    __resize = () => this._resize();
    __scroll = (e) => this._scroll(e);

    constructor() {
        this._$nav = $("[mu-nav-mobile]");
        this._$hamburger = $("[mu-hamburger]");
        if (this._$nav) {
            this._init();
        }
    }

    set tabbing(value) {
        $(
            ".nav-level-1 > li > a, .nav-level-1 > li > button, .nav-utililty > li > a, .nav-mobile-home, .nav-utility a",
            this._$nav
        ).attr("tabindex", value ? 0 : -1);
    }

    set deactive(value) {
        this._deactive = value;
        this.tabbing = !value;
        if (!value) {
            this._$navPrimary.removeClass("is-deactive");
        } else {
            this._$navPrimary.addClass("is-deactive");
        }
    }

    get deactive() {
        return this._deactive;
    }

    get navToggle() {
        return this._$navToggle;
    }

    get navPrimary() {
        return this._$navPrimary;
    }

    get scrollTop() {
        return this._scrollTop;
    }

    getActiveNav() {
        return this._navItems.filter((nav) => nav.hasActivePath);
    }

    _init() {
        this._$navPrimary = $(".nav-primary", this._$nav);
        $('a, button', this._$nav).attr('tabindex', -1);
        this._$body = $(document.body);
        this._$navOverlay = $(
            '<div class="nav-overlay" role="button" aria-label="Close navigation"></div>'
        );
        this._$body.append(this._$navOverlay);
        this._$navToggle = $("[mu-hamburger],[mu-search]", this._$nav);
        this.__keyDown = (e) => this._keyDown(e);

        $("[mu-nav-mobile-secondary] > .nav-item", this._$nav).each(
            (i, item) => {
                this._navItems.push(
                    new MuNavSecondary(this, item, {
                        open: () => this._secondaryNavOpen(),
                        close: () => this._secondaryNavClose(),
                    })
                );
            }
        );
        // actions
        this._$navToggle.on("click", (e) => this._toggle(e));
        this._$navOverlay.on("click", () => this.close());
    }

    _resize() {
        this._$navPrimary.innerHeight(
            window.innerHeight - this._$nav[0].getBoundingClientRect().top
        );
        // Close on resize
        if (window.innerWidth > this._desktopWidth) {
            this.close();
        }
    }

    _scroll(e) {
        if (!this._deactive) {
            this._scrollTop = this._$navPrimary[0].scrollTop;
            var hideToggle = this._scrollTop > 30;
            if (hideToggle && !this._$navToggle.hasClass("fade-out")) {
                this._$navToggle.addClass("fade-out");
            }
            if (!hideToggle && this._$navToggle.hasClass("fade-out")) {
                this._$navToggle.removeClass("fade-out");
            }
        }
    }

    open() {
        if (!this._isOpen) {
            this._isOpen = true;
            document.body.style.overflowY = "hidden";
            this._$navOverlay.fadeIn(300);
            this._$hamburger.removeClass("collapsed");
            this._$nav.addClass("is-open");

            const parentRect = this._$nav.parent()[0].getBoundingClientRect();
            this._$navPrimary[0].style.marginTop = `${parentRect.top + parentRect.height}px`;

            this._$navToggle.addClass("is-open");
            this._$navToggle.attr("aria-expanded", true);
            this.tabbing = true;

            const activeNav = this.getActiveNav();
            if (activeNav[0]) {
                activeNav[0].activate();
            }

            $("header").addClass("overflow-visible");

            document.addEventListener("keydown", this.__keyDown, false);
            window.addEventListener("resize", this.__resize);
            this._$navPrimary[0].addEventListener("scroll", this.__scroll);
            this._resize();
        }
    }

    close() {
        if (this._isOpen) {
            this._isOpen = false;
            this._$navPrimary[0].removeEventListener("scroll", this.__scroll);
            window.removeEventListener("resize", this.__resize);
            document.removeEventListener("keydown", this.__keyDown);
            this._$hamburger.addClass("collapsed");
            this._$nav.removeClass("is-open");
            this._$navToggle.removeClass("is-open");
            this._$navToggle.attr("aria-expanded", false);
            this._$navOverlay.fadeOut(300);
            this._$navToggle[0].focus({ preventScroll: true });
            this.closeAll();
            this.tabbing = false;
            document.body.style.overflowY = "inherit";
            this._$navToggle.removeClass("fade-out");

            $("header").removeClass("overflow-visible");
        }
    }

    _secondaryNavOpen() {
        this.deactive = true;
    }

    _secondaryNavClose() {
        this.deactive = false;
    }

    _keyDown(e) {
        this._$lastNavItem = this._$nav.find('[tabindex="0"]').last();
        if (this._$navToggle.is(e.target) && e.shiftKey === true) {
            e.preventDefault();
            this._$lastNavItem[0].focus({ preventScroll: true });
        }
        if (
            this._$lastNavItem.is(e.target) &&
            e.shiftKey === false &&
            e.keyCode !== 13
        ) {
            e.preventDefault();
            this._$navToggle[0].focus({ preventScroll: true });
        }
    }

    _toggle(e) {
        e.preventDefault();
        if (!this._isOpen) {
            this.open();
        } else {
            this.close();
        }
    }

    closeAll() {
        this._navItems.forEach((item) => {
            item.close();
        });
    }
}

class MuNavSecondary {
    _mainNav;
    _$navToggle;
    _$mainToggle;
    _$nav;
    _$lastNavItem;
    _$tabItems;
    _navSections = [];
    __resize = () => this._resize();
    __keyDown = (e) => this._keyDown(e);
    __scroll = (e) => this._scroll(e);
    _activePath;
    _scrollTop = 0;

    constructor(mainNav, nav, events) {
        this._mainNav = mainNav;
        this._events = events;
        this._$mainToggle = mainNav.navToggle;
        this._$nav = $(nav);
        if (this._$nav.length > 0 && this._$mainToggle.length > 0) {
            this._init();
        }
    }

    get hasActivePath() {
        return this._activePath ? this._activePath.hasActivePath : false;
    }

    set tabbing(value) {
        if (this._$tabItems) {
            this._$tabItems.attr("tabindex", value ? 0 : -1);
        }
    }

    _init() {
        const level = $("> .nav-level-2 > .nav ", this._$nav)[0];
        if (level) {
            this._activePath = new MuNavOpenActivePath(this._$nav[0]);
            this._$navToggle = $("> button", this._$nav);
            this._$navToggle.on("click", (e) => this._toggle(e));
            this._$backToggle = this._$navToggle.next().find(".nav-btn-arrow");
            this._$backToggle.on("click", () => this.close());

            this._$tabItems = $(
                `> .nav > .nav-level-2-title > a, 
                 > .nav > .nav-level-2-title > button,
                 > .nav > .nav > .nav-item > .nav-title-container > a,
                 > .nav > .nav > .nav-item > .nav-title-container > button,
                 > .nav > .nav > .is-open [tabindex]`,
                this._$nav
            );
            this._$navContainer = $(".nav-level-2", this._$nav);
            this._navToggles = new MuNavToggles(level, "> .has-children");
        }
    }

    activate() {
        this._$navContainer[0].style.marginTop = `${this._mainNav.scrollTop}px`;
        this._$navToggle.parent().addClass("is-open");
        this._$navToggle.attr("aria-expanded", true);

        this._activePath.active();
        this.tabbing = true;
        this._$backToggle[0].focus({ preventScroll: true });
        document.addEventListener("keydown", this.__keyDown, false);
        window.addEventListener("resize", this.__resize);
        this._$navContainer[0].addEventListener("scroll", this.__scroll);
        this._events.open();
        this._resize(); 
    }

    deactive() {
        window.removeEventListener("resize", this.__resize);
        document.removeEventListener("keydown", this.__keyDown);
        this._$navContainer[0].removeEventListener("scroll", this.__scroll);
        if (this._$navToggle) {
            this._$navToggle.parent().removeClass("is-open");
            this._$navToggle.attr("aria-expanded", false);
            this.tabbing = false;
            this._events.close();
        }
    }

    open() {
        if (
            this._$navToggle &&
            !this._$navToggle.parent().hasClass("is-open")
        ) {
            this.activate();
        }
    }

    close() {
        if (this._$navToggle && this._$navToggle.parent().hasClass("is-open")) {
            this.deactive();
        }
    }

    _scroll(e) {
        var hideToggle = this._$navContainer[0].scrollTop > 30;
        if (hideToggle && !this._$mainToggle.hasClass("fade-out")) {
            this._$mainToggle.addClass("fade-out");
        }
        if (!hideToggle && this._$mainToggle.hasClass("fade-out")) {
            this._$mainToggle.removeClass("fade-out");
        }
    }

    _resize() {
        this._$navContainer.innerHeight(
            window.innerHeight -
                this._$navContainer[0].getBoundingClientRect().top
        );
    }

    _keyDown(e) {
        this._$lastNavItem = $('[tabindex="0"]', this._$nav.last());
        if (this._$mainToggle.is(e.target) && e.shiftKey === true) {
            e.preventDefault();
            this._$lastNavItem[0].focus({ preventScroll: true });
        }
        if (
            this._$lastNavItem.is(e.target) &&
            e.shiftKey === false &&
            e.keyCode !== 13
        ) {
            e.preventDefault();
            this._$mainToggle[0].focus({ preventScroll: true });
        }
    }

    _toggle(e) {
        if (!this._$navToggle.parent().hasClass("is-open")) {
            this.open();
        } else {
            this.close();
        }
    }
}
